module.exports = __webpack_public_path__ + "static/img/freshman-blocky.af07c09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/freshman-blocky.png
// module id = cmHB
// module chunks = 1